// src/Pages/socket/socket.js
import { io } from "socket.io-client";

export default function createSocket(userDetails) {
  return io(process.env.REACT_APP_API_URL, {
    autoConnect: false,          // manually control connection
    transports: ["websocket"],   // skip long-polling
    auth: {
      role: "hospital",          // or "doctor" depending on the component
      _id:
        userDetails?.data?.hospitalProfile?._id
    },
  });
}
